export const airportCodeMap = new Map<string, string>([
  ["LON", "All London Airports"],
  // ["LHR", "London Heathrow"], // Must be removed once "All London Airports" is propagated
  // ["LGW", "London Gatwick"], // Must be removed once "All London Airports" is propagated
  // ["STN", "London Stansted"], // Must be removed once "All London Airports" is propagated
  // ["LTN", "London Luton"], // Must be removed once "All London Airports" is propagated
  // ["LCY", "London City"], // Must be removed once "All London Airports" is propagated
  // ["SEN", "London Southend"], // Must be removed once "All London Airports" is propagated
  ["BRS", "Bristol"],
  ["BHX", "Birmingham"],
  ["MAN", "Manchester"],
  ["LPL", "Liverpool"],
  ["EMA", "East Midlands"],
  ["LBA", "Leeds Bradford"],
  ["NCL", "Newcastle"],
  ["EDI", "Edinburgh"],
  ["GLA", "Glasgow"],
  ["CWL", "Cardiff"],
  ["ABZ", "Aberdeen"],
  ["BFS", "Belfast"],
  ["BOH", "Bournemouth"],
  ["SOU", "Southampton"],
  ["EXT", "Exeter"],
  ["DUB", "Dublin"],
  ["GCI", "Guernsey"],
  ["None", "NA"]
]);
